import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { Flex, Box } from 'reflexbox';
import { color } from 'd3-color';

import { getColor, getName, getSubline, hasColor, getTextColor } from '../../config';

import SeatVis from './SeatVis';

const PartyItem = ({ name, shortName, seats }) => {
  const color = getColor(shortName);
  const textColor = getTextColor(shortName);
  const isSmall = !hasColor(shortName);
  const textStyle = { color: textColor };
  const itemClasses = classnames('party-item', { 'is-small' : isSmall });

  return (
    <Flex className={itemClasses} align="flex-start">
      <SeatVis color={color} align="left" seats={seats} />
      <div style={textStyle} className="seat-number">{seats}</div>
      <div style={textStyle} className="party-name" key={name}>{getName(shortName)}</div>
    </Flex>
  );
};


class GroupItem extends PureComponent {
  render() {
    const { data } = this.props;
    const { seatsTotal, partiesDE, seatsTotalDE } = data;
    const partiesDESorted = partiesDE.sort((a, b) => b.seats - a.seats);
    const hexColor = getColor(data.shortName);
    const bgColor = color(hexColor);
    bgColor.opacity = 0.1;
    const wrapperStyle = { backgroundColor: bgColor.toString() };
    const mainPartyStyle = { color: getTextColor(data.shortName) };
    const classes = classnames('result-group', `group-${data.shortName}`);

    return (
      <Flex style={wrapperStyle} className={classes}>
        <Flex style={mainPartyStyle} className="result-group__eu">
          <Box className="result-group__faction">
            <div className="result-group__name">
              {getName(data.shortName)}
            </div>
            <div className="result-group__perc">
              {data.seatsPercentEU} %
            </div>
            <div className="result-group__text">
              {getSubline(data.shortName)}
            </div>
          </Box>
           <Flex align="flex-start" justify="flex-end" className="result-group__seatvis">
            <div style={mainPartyStyle} className="seat-number">{seatsTotal}</div>
            <SeatVis cutout={seatsTotalDE} color={hexColor} align="right" seats={seatsTotal} />
          </Flex>
        </Flex>
        <Flex column className="result-group__de">
          {partiesDESorted.map(party => <PartyItem key={party.name} {...party}/>)}
        </Flex>
      </Flex>
    );
  }
}

export default GroupItem;
